'use es6';

import { Record } from 'immutable';

class PixelAdAccount extends Record({
  accountName: null,
  accountId: null,
  network: null,
  status: null,
  accessibleToPrimaryUser: null,
  currentUserHasConnected: null,
  canCreateAudiences: null,
  getDisplayName: null,
  getFormattedName: null,
  limitedDataUseEnabled: null
}) {
  static fromLegacyAdAccount(adAccount, currentUserHasConnected) {
    return new PixelAdAccount({
      accountName: adAccount.accountName,
      accountId: adAccount.accountId,
      network: adAccount.network,
      status: adAccount.status,
      accessibleToPrimaryUser: adAccount.accessible,
      currentUserHasConnected,
      canCreateAudiences: adAccount.canCreateAudiences,
      getDisplayName: adAccount.getDisplayName.bind(adAccount),
      getFormattedName: adAccount.getFormattedName.bind(adAccount),
      limitedDataUseEnabled: adAccount.limitedDataUseEnabled
    });
  }

  static fromAccountOverview(adAccount, currentUserHasConnected, canCreateAudiences) {
    return new PixelAdAccount({
      accountName: adAccount.accountName,
      accountId: adAccount.accountId,
      network: adAccount.network,
      status: adAccount.status,
      accessibleToPrimaryUser: adAccount.accessibleToPrimaryUser,
      currentUserHasConnected,
      getDisplayName: adAccount.getDisplayName.bind(adAccount),
      getFormattedName: adAccount.getFormattedName.bind(adAccount),
      canCreateAudiences,
      limitedDataUseEnabled: adAccount.limitedDataUseEnabled
    });
  }

}

export default PixelAdAccount;